import React, { Component } from 'react'
import { Line } from 'react-chartjs-2'
import moment from 'moment'
import localization from 'moment/locale/de'

const options = {
    scales: {
        xAxes: [{
            type: 'time',
            distribution: 'linear',
            ticks: {
                source: 'data',
            },
            time: {
                unit: 'hour',
                stepSize: 3,
                displayFormats: {
                    hour: 'HH:mm',
                },
            },
        }],
        yAxes: [{
            ticks: {
                min: 0,
                max: 100,
            },
        }],
    },
    maintainAspectRatio: false,
    tooltips: {
        callbacks: {
            title(tooltipItem, data) {
                const time = data.datasets[0].data[tooltipItem[0].index].x
                return `${moment(time).locale('de', localization).calendar()}`
            },
            label(tooltipItem) {
                return ` ${tooltipItem.yLabel}%`
            },
        },
    },
}

class MoistureChart extends Component {
    constructor() {
        super()

        this.state = {}
    }

    getData() {
        const { data } = this.props

        const values = data.map(entry => ({
            x: new Date(entry.timestamp),
            y: entry.moisture,
        }))

        if (values.length > 0 &&
            Math.abs(data[0].timestamp - (new Date().getTime())) > 3 * 60 * 60 * 1000) {
            values.push({
                x: new Date(),
                y: null,
            })
        }

        return {
            datasets: [
                {
                    label: 'Bodenfeuchte',
                    fill: false,
                    lineTension: 0.4,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 5,
                    pointHitRadius: 10,
                    cubicInterpolationMode: 'default',
                    spanGaps: true,
                    borderWidth: 1,
                    data: values,
                },
            ],
        }
    }

    render() {
        return (
            <div>
                <Line height={300} data={this.getData()} options={options} />
            </div>
        )
    }
}

export default MoistureChart



// WEBPACK FOOTER //
// ./src/components/Devices/MoistureChart.js